import { graphql } from '~/lib/graphql'

export const RestaurantHighlights = graphql(/* GraphQL */ `
  fragment RestaurantHighlights on Restaurant {
    restaurantId
    highlights {
      title
      description
      imageAlt
      image {
        url
      }
    }
  }
`)
